import { useEffect, useState } from "react";
import Card from "../Card";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "src/base-components/Button";
import { selectCustomerInfo } from "src/stores/calllogs";
import ViewQueryModal from "./callAnswered/ViewQueryModal";
import { UserActionType, getUserActionHistory } from "./utils/actionTracker";
import axios from "axios";
import { apiBaseUrl } from "src/services/http";

export const ExistingQuery = ({
  selectedQuery,
  onSelect,
  disabled = false,
  hideSelect = false,
  code,
  currentQueryValue,
  onActionTrack,
  callerInfo,
}: {
  selectedQuery?: any; // optional
  onSelect?: (q: any) => void;
  disabled?: boolean;
  hideSelect?: boolean;
  code?: string;
  currentQueryValue?: string | null;
  onActionTrack?: (actionType: UserActionType, queryId: string) => void;
  callerInfo?: any;
}) => {
  const [openViewModal, setOpenViewModal] = useState<boolean>(false);
  const [getqueryID, setGetQueryID] = useState<string | null>(null);

  const navigate = useNavigate();
  const customerInfo = useSelector(selectCustomerInfo);
  const result = customerInfo?.data?.result;
console.log('====================================');
console.log(selectedQuery , "selectedQueryselectedQueryselectedQuery");
console.log('====================================');
  // Safely extract queries and customer
  const existingQueries = result?.queries ?? [];
  useEffect(() => {
    console.log(
      existingQueries,
      "existingQueriesexistingQueriesexistingQueriesexistingQueries",
    );
  }, [existingQueries]);
  const customer = result?.customer ?? null;
  const normalizedCode = String(code || "")
    .trim()
    .toLowerCase();
  const codeForcesHide = code ? normalizedCode !== "answered" : false;
  console.log(codeForcesHide, "codeForcesHidecodeForcesHidecodeForcesHide");
  const handleClose = () => {
    setGetQueryID(null);
    setOpenViewModal(false);
  };

  const shouldDisable =
    currentQueryValue !== undefined && String(currentQueryValue).trim() !== "";

  // Send tracked action to API (only when code is "Answered")
  const sendActionToAPI = async (
    actionType: UserActionType,
    queryId: string,
    queryNo?: string,
  ) => {
    // Only send actions if code is "Answered"
    if (normalizedCode !== "answered") {
      console.log("Actions only sent when code is 'Answered'");
      return;
    }

    try {
      
      const authToken = (() => {
        try {
          const root = JSON.parse(localStorage.getItem("persist:root") || "{}");
          const authUserData = root?.authUser
            ? JSON.parse(root.authUser)
            : null;
          return authUserData?.token || authUserData?.access_token || null;
        } catch (e) {
          return null;
        }
      })();

      const formData = new FormData();
      // Use callerInfo?.sessionId - it's required by the API
      formData.append(
        "session_id",
        callerInfo?.sessionId || callerInfo?.session_id || "",
      );
      // Include query number in log text if available
      const logText = queryNo ? ` ${actionType} #${queryNo}` : actionType;
      formData.append("log_text", logText);

      const config: any = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      // Add authorization header if token exists
      if (authToken) {
        config.headers["Authorization"] = `Bearer ${authToken}`;
      }

      const response = await axios.post(
        `${apiBaseUrl}/save/call-activity/log`,
        formData,
        config,
      );

      console.log("Action sent to API successfully:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error sending action to API:", error);
      throw error;
    }
  };

  return (
    <>
      <div className="space-y-4">
        <h4 className="font-medium text-gray-900  text-lg">
          Choose Existing Query
        </h4>
        <div
          className={`grid grid-cols-2 gap-3 max-h-[320px] ${
            existingQueries &&
            existingQueries?.length > 2 &&
            "overflow-y-auto pr-2"
          }`}
        >
          {existingQueries?.map((query) => {
            const paxCount =
              (query?.no_of_adults ?? 0) +
              (query?.no_of_children ?? 0) +
              (query?.no_of_infants ?? 0);
            const isSelected = selectedQuery != null && String(selectedQuery?.id) === String(query.id);

            console.log(isSelected, "isSelectedisSelectedisSelectedisSelected");
            
            return (
              <Card
                key={query.id}
                className={`p-3 cursor-pointer transition-all ${
                  isSelected
                    ? "border-blue-500 bg-blue-50"
                    : "border-gray-200 hover:border-gray-300"
                }`}
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="font-medium text-blue-600">
                    {query.query_no}
                  </span>
                  <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                    {query.stage_text}
                  </span>
                </div>
                <p className="text-sm text-gray-900 mb-1">
                  {customer?.fullname}
                </p>
                <div className="flex justify-between text-xs text-gray-500">
                  <span>Customer ID: {customer?.customer_id}</span>
                  <span>No. of PAX: {paxCount}</span>
                </div>
                <div
                  className={`flex ${
                    hideSelect || codeForcesHide
                      ? "justify-end"
                      : "justify-between"
                  } mt-3`}
                >
                  {normalizedCode === "answered" && (
                    <button
                      type="button"
                      className={`w-fit ${
                        isSelected
                          ? "border border-blue-500 bg-blue-50"
                          : "bg-[#233580] text-white"
                      } ${
                        shouldDisable && !isSelected
                          ? "bg-gray-500 cursor-not-allowed"
                          : ""
                      } p-2 rounded-lg text-xs font-medium`}
                      onClick={() => {
                        // Prevent selecting when disabled, but allow unselecting
                        if (shouldDisable && !isSelected) return;
                        onSelect?.(isSelected ? null : query);

                        // Track action only if code is "Answered" and selecting (not unselecting)
                        if (!isSelected && normalizedCode === "answered" && onActionTrack) {
                          onActionTrack(
                            "Query Selected for assigning current call",
                            query.id,
                          );
                          // Send this specific action to API
                          sendActionToAPI(
                            "Query Selected for assigning current call",
                            query.id,
                            query.query_no,
                          );
                        }
                      }}
                      disabled={shouldDisable && !isSelected}
                    >
                      {isSelected ? "Unselect" : "Select"}
                    </button>
                  )}

                  <button
                    type="button"
                    className="w-fit bg-[#233580] text-white p-2 rounded-lg text-xs font-medium"
                    onClick={() => {
                      setOpenViewModal(true);
                      setGetQueryID(query.id);

                      // Track action only if code is "Answered"
                      if (normalizedCode === "answered" && onActionTrack) {
                        onActionTrack("Existing Query Viewed", query.id);
                        // Send this specific action to API
                        sendActionToAPI(
                          "Existing Query Viewed",
                          query.id,
                          query.query_no,
                        );
                      }
                    }}
                  >
                    View
                  </button>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
      <ViewQueryModal
        openViewModal={openViewModal}
        getqueryID={getqueryID}
        handleClose={handleClose}
      />
    </>
  );
};
